import { Component, OnInit, Inject } from '@angular/core';
import { IConfig } from '../../../dt-an-prequalification-lib/src/lib/interfaces/config.interface';

@Component({
  selector: 'dt-credit-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'dt-an-prequalification-app';
  isBuyNow = false;
  apiDomain= false;
  constructor(@Inject('config') public SitecoreConfig: IConfig) { }
  ngOnInit() {
    if (
      this.SitecoreConfig &&
      this.SitecoreConfig.Sitecore &&
      this.SitecoreConfig.Sitecore.CreditApplicationConfig
    ) {
      this.isBuyNow = this.SitecoreConfig.Sitecore.isBuyNow;
      this.apiDomain = this.SitecoreConfig.Sitecore.apiDomain  ? true : false; 
      if(this.apiDomain) {
        document.body.style.overflow = 'hidden';
      }
    }
  }

}
